/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Try_Library_PromptInputs */

const en_mcp_try_library_prompt = /** @type {(inputs: Mcp_Try_Library_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show my five most recent Listening documents and whether they're ready.`)
};

const es_mcp_try_library_prompt = /** @type {(inputs: Mcp_Try_Library_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muéstrame mis cinco documentos más recientes de Listening y si ya están listos.`)
};

/**
* | output |
* | --- |
* | "Show my five most recent Listening documents and whether they're ready." |
*
* @param {Mcp_Try_Library_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_try_library_prompt = /** @type {((inputs?: Mcp_Try_Library_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Try_Library_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_try_library_prompt(inputs)
	return en_mcp_try_library_prompt(inputs)
});